import { Row, Col, Typography, Image } from 'antd';
import { useQuery } from 'react-query';
import carIcon from '../../../assets/Car and checkmark 2.png';
import speedometerIcon from '../../../assets/Car speedometer dial 1.png';
import styles from './styles';
import HomeCard from '../HomeCard';

export default function ContractInfo() {
  const { data } = useQuery('getContractInfo');
  const { Text } = Typography;

  return (
    <HomeCard title="Στοιχεία Συμβολαίου">
      <Row align="middle" style={styles.durationRow}>
        <Col flex="none" style={styles.colIcon}>
          <Image src={carIcon} width={32} preview={false} />
        </Col>
        <Col flex="auto">
          <Col span={24}>
            <Text type="secondary" style={styles.label}>
              ΔΙΑΡΚΕΙΑ ΣΥΜΒΟΛΑΙΟΥ
            </Text>
          </Col>
          <Col span={24}>
            <Text strong>
              {data.startDate} - {data.endDate}
            </Text>
          </Col>
        </Col>
      </Row>
      <Row align="middle" style={styles.limitRow}>
        <Col flex="none" style={styles.colIcon}>
          <Image src={speedometerIcon} width={32} preview={false} />
        </Col>
        <Col flex="auto">
          <Col span={24}>
            <Text type="secondary" style={styles.label}>
              ΟΡΙΟ ΧΙΛΙΟΜΕΤΡΩΝ
            </Text>
          </Col>
          <Col span={24}>
            <Text strong>{data.currentPackageDuration}</Text>
          </Col>
        </Col>
      </Row>
    </HomeCard>
  );
}
